export default {
    1: 'Monthly',
    3: 'Quarterly',
    12: 'Annual'
}